import styled from 'styled-components';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';

const InputMoney = styled(CurrencyTextField)`
  background: rgba(51, 51, 51, 0.05);
  border-radius: 4px 4px 0px 0px;

  .MuiInputBase-root {
    background: ${(props) => props.background};
    width: ${(props) => props.width};
  }

  .MuiInputBase-input {
    margin-left: 1.389vw;
    margin-right: 1vw;
  }

  .MuiFilledInput-input {
    padding: 20px 12px 10px;
  }

  .MuiInputBase-root {
    background-color: transparent;
  }

  .MuiInputLabel-filled.MuiInputLabel-shrink {
    transform: translate(12px, 2px) scale(0.75);
  }
`;

export default InputMoney;
